"use client"

import { CalendarIcon } from "lucide-react"
import { format } from "date-fns"
import { useState } from "react"
import { Calendar } from "./calendar"
import { Popover, PopoverTrigger, PopoverContent } from "./popover"
import { Button } from "./button"
import { cn } from "../../utils/cn"

interface MonthYearPickerProps {
  selected: Date | undefined
  onChange: (date: Date | undefined) => void
  className?: string
}

export function MonthYearPicker({ selected, onChange, className }: MonthYearPickerProps) {
  const [open, setOpen] = useState(false)

  const handleSelect = (date: Date | undefined) => {
    if (!date) return
    const normalized = new Date(date.getFullYear(), date.getMonth(), 1)
    onChange(normalized)
    setOpen(false)
  }

  const handleMonthChange = (month: Date) => {
    const normalized = new Date(month.getFullYear(), month.getMonth(), 1)
    onChange(normalized)
  }

  return (
    <div className={cn("grid gap-2 font-semibold", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="default"
            size="sm"
            className={cn("justify-start text-left w-[200px]", !selected && "text-muted-foreground")}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {selected ? format(selected, "MMMM yyyy") : <span>Pick a month</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          align="start"
          sideOffset={2}
          className="p-2 w-45 h-20"
        >
          <Calendar
            mode="single"
            captionLayout="dropdown"
            selected={selected}
            defaultMonth={selected ?? new Date()}
            onSelect={handleSelect}
            onMonthChange={handleMonthChange}
            startMonth={new Date(2024, 0, 1)}
            endMonth={new Date(new Date().getFullYear(), 11, 31)}
            autoFocus
            className="remove-days month-year-picker"
            classNames={{
              day: "hidden",
              weekdays: "hidden",
              caption_label: "hidden",
              dropdowns: "flex justify-center items-center gap-4 w-full mt-2 text-foreground",
              nav: "hidden",
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}